import React, { useState } from 'react';
import styles from './Dashboard.module.css';

const Dashboard = () => {
    return (
        <div className={styles.dashboardContainer}> 

        </div>
    );
};

export default Dashboard;
